import CustomisableWidgetEditor from './base/customisable-widget-editor';
import Em from 'ember';
export default CustomisableWidgetEditor.extend({
  autoFocusSelector: 'input:first',
  classNames: ['ic-popup', 'ic-popup-above', 'ic-popup-short', 'is-light-theme', 'social-widget-editor'],
  keysToTriggerClose: [13, 27],
  isWithinViewport: true,
  propertyCleaners: ['cleanTwitter', 'cleanFacebook'],
  init() {
    this._super(...arguments);
    this.set('twitterBefore', this.get('twitter.value'));
    this.set('facebookBefore', this.get('facebook.value'));
  },
  facebook: Em.computed('emailTemplateData.[]', 'emailTemplateData.@each.value', function () {
    return this.findEmailTemplateDatum('facebook');
  }),
  twitter: Em.computed('emailTemplateData.[]', 'emailTemplateData.@each.value', function () {
    return this.findEmailTemplateDatum('twitter');
  }),
  cleanTwitter() {
    let twitter = this.get('twitter');
    let match = twitter.get('value').match(/(?:https?:\/\/)?(?:www\.)?twitter.com\/([^\?]+)/);
    if (match) {
      twitter.set('value', match[1]);
    }
  },
  cleanFacebook() {
    let facebook = this.get('facebook');
    let match = facebook.get('value').match(/(?:https?:\/\/)?(?:www\.)?facebook.com\/([^\?]+)/);
    if (match) {
      facebook.set('value', match[1]);
    }
  },
  actions: {
    dismiss() {
      let changes = [];
      let twitterNow = this.get('twitter.value');
      let facebookNow = this.get('facebook.value');
      if (this.get('twitterBefore') !== twitterNow) {
        changes.push({
          identifier: 'twitter',
          value: twitterNow
        });
      }
      if (this.get('facebookBefore') !== facebookNow) {
        changes.push({
          identifier: 'facebook',
          value: facebookNow
        });
      }
      this.closeEditor(changes);
    }
  }
});